import SEO from "@/components/SEO";
import { ShieldCheck, Trophy, Certificate, Heart, Wrench, Headset } from "@phosphor-icons/react";

const TEAM = [
  { name: "Jean-Marc", role: "Chef d'atelier", exp: "40 ans d'expertise" },
  { name: "Fabien", role: "Mécanicien confirmé", exp: "20 ans d'expertise" },
  { name: "Nathan", role: "Mécanicien", exp: "5 ans d'expertise" },
  { name: "Kimberley", role: "Secrétaire & assistante", exp: "6 ans d'expérience" },
];

export default function TeamPage() {
  return (
    <>
      <SEO
        title="L'équipe — MECA AUTO 17 Tonnay-Charente | Mécaniciens Qualifiés"
        description="Découvrez l'équipe de MECA AUTO 17 à Tonnay-Charente : mécaniciens certifiés, techniciens diagnostic, carrossiers, plus de 10 ans d'expérience à votre service."
      />
      <section className="pt-32 pb-16 px-6 md:px-12 bg-[#0D2C54] text-white">
        <div className="max-w-[1400px] mx-auto">
          <span className="overline text-[#E63946]">L'équipe</span>
          <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight max-w-3xl">
            Des experts passionnés, à votre écoute.
          </h1>
          <p className="mt-6 text-white/80 max-w-2xl text-lg">
            Notre équipe pluridisciplinaire allie expérience constructeur et formation continue pour vous offrir un service irréprochable.
          </p>
        </div>
      </section>

      <section className="py-20 md:py-28 px-6 md:px-12 bg-white">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#E5E7EB] border border-[#E5E7EB]">
            {TEAM.map((m, i) => {
              const Icon = m.role.toLowerCase().includes("mécan") || m.role.toLowerCase().includes("atelier") ? Wrench : Headset;
              return (
                <div data-testid={`team-${i}`} key={m.name} className="bg-white group p-8 md:p-10">
                  <div className="w-20 h-20 bg-[#0D2C54] flex items-center justify-center mb-6 transition-transform group-hover:scale-105">
                    <span className="font-display font-bold text-3xl text-white">{m.name.charAt(0)}</span>
                  </div>
                  <Icon size={20} weight="duotone" className="text-[#E63946] mb-4" />
                  <h3 className="font-display font-semibold text-2xl text-[#0D2C54]">{m.name}</h3>
                  <div className="text-xs overline text-[#E63946] mt-2">{m.role}</div>
                  <p className="mt-4 text-sm text-[#555555]">{m.exp}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28 px-6 md:px-12 bg-[#F8F9FA]">
        <div className="max-w-[1400px] mx-auto">
          <div className="grid md:grid-cols-12 gap-12">
            <div className="md:col-span-6">
              <span className="overline text-[#E63946]">Nos valeurs</span>
              <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0D2C54] tracking-tight">
                10 ans d'engagement pour la mobilité parisienne.
              </h2>
              <p className="mt-6 text-[#555555] text-base leading-relaxed">
                Depuis 2015, MECA AUTO 17 s'engage à fournir un service mécanique de qualité, à prix juste, avec une transparence totale, à Tonnay-Charente et alentours. Nous formons en continu nos équipes aux nouvelles technologies (hybride, électrique, ADAS) pour rester à la pointe.
              </p>
            </div>
            <div className="md:col-span-6 grid grid-cols-2 gap-px bg-[#E5E7EB] border border-[#E5E7EB]">
              {[
                { icon: Trophy, t: "Excellence", d: "Note moyenne de 4,9/5 sur 240+ avis Google." },
                { icon: ShieldCheck, t: "Transparence", d: "Devis détaillé avant toute intervention." },
                { icon: Certificate, t: "Certifications", d: "Techniciens habilités hybride et électrique." },
                { icon: Heart, t: "Proximité", d: "Conseils personnalisés et suivi client." },
              ].map((v, i) => (
                <div key={i} className="bg-white p-6">
                  <v.icon size={28} weight="duotone" className="text-[#E63946]" />
                  <h4 className="mt-4 font-display font-semibold text-[#0D2C54]">{v.t}</h4>
                  <p className="mt-2 text-sm text-[#555555] leading-relaxed">{v.d}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
